import { buildParams, CoreAPI } from '../../../Services/CoreAPI'

export const obtainEsrbByFilter = async (filter) => {
  let endpoint = '/v1/esrb'

  if (filter) {
    const params = buildParams(filter)
    endpoint = `/v1/esrb?${params.toString()}`
  }

  const resp = await CoreAPI.get(endpoint)

  const {
    data: list = [],
    pagination: { totalPages = 1 } = {}
  } = resp

  if (list?.data) {
    return { list: list.data, totalPages }
  } else {
    return { list, totalPages }
  }
}

export const obtainEsrbById = async (esrbId) => {
  const endpoint = `/v1/esrb/${esrbId}`
  const resp = await CoreAPI.get(endpoint)

  if (resp.data?.data) {
    return resp.data.data
  }

  return resp.data
}

export const createEsrb = async (data) => {
  const endpoint = '/v1/esrb'
  const resp = await CoreAPI.post(endpoint, data)
  return resp.data
}

export const updateEsrb = async (esrbId, data) => {
  const endpoint = `/v1/esrb/${esrbId}`
  const resp = await CoreAPI.put(endpoint, data)
  return resp.data
}

export const deleteEsrb = async (esrbId) => {
  const endpoint = `/v1/esrb/${esrbId}`
  const resp = await CoreAPI.delete(endpoint)
  return resp.data
}
